<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter" id="don">
<p class="eds">A portion of the proceeds from the sale of this book will be donated to Save a Child’s Heart. The results of their work are a testament to the power of compassion.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// rbgfeder0005.vue?e82feb78